// Base
import { Fragment } from "react";

// Components
import { Card, RowCard } from "@/components";

export function List({
  userId,
  showDates,
  showAsRow = false,
  data,
  title,
  collectionHandle,
}) {
  return (
    <div className="flex flex-col space-y-5 ">
      <h2 className="level-2">My {title}</h2>
      <div
        className={
          !showAsRow
            ? "grid grid-cols-2 lg:grid-cols-4 gap-4"
            : "grid gap-4 grid-cols-1"
        }
      >
        {data?.map((item, index) => (
          <Fragment key={index}>
            {showAsRow ? (
              <RowCard
                userId={userId}
                key={index}
                showDates={showDates}
                selectedDay={{ slug: "all-days" }}
                title={item?.title}
                image={
                  collectionHandle == "showbags" ? item.image : item?.grid_image
                }
                url={`${collectionHandle}/${item?.slug}`}
                data={item}
                collectionHandle={collectionHandle}
                price={item?.showbag_price}
              />
            ) : (
              <Card
                userId={userId}
                key={index}
                showDates={showDates}
                selectedDay={{ slug: "all-days" }}
                title={item?.title}
                image={
                  collectionHandle == "showbags" ? item.image : item?.grid_image
                }
                url={`${collectionHandle}/${item?.slug}`}
                data={item}
                collectionHandle={collectionHandle}
                price={item?.price}
              />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
}
